export const  notificationManagementEndpoints = {
    notification: {
        list: {
            api: '/api/mercury/new-notifications/list',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/mercury/new-notifications/details',
            method: 'GET',
            parameter: true
        },
        detailsByKey: {
            api: '/api/mercury/new-notifications/detailsbykey',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/mercury/new-notifications/add',
            method: 'POST',
            parameter: true
        },
        edit: {
            api: '/api/mercury/new-notifications/update',
            method: 'POST',
            parameter: true
        },
        broadcast: {
            list: {
                api: '/api/mercury/new-notifications/list',
                method: 'GET',
                parameter: false
            }
        },
        testTemplate: {
            api: '/api/mercury/new-notifications/testTemplate',
            method: 'POST',
            parameter: true
        }
    },
    broadcastNotification: {
        proceedList: {
            api: '/api/mercury/broadcast-notifications/proceedList',
            method: 'GET',
            parameter: false
        },
        proceedDetails: {
            api: '/api/mercury/broadcast-notifications/proceedDetails',
            method: 'GET',
            parameter: true
        },
        inProgressList: {
            api: '/api/mercury/broadcast-notifications/inProgressList',
            method: 'GET',
            parameter: false
        },
        inProgressDetails: {
            api: '/api/mercury/broadcast-notifications/inProgressDetails',
            method: 'GET',
            parameter: true
        },
        countTargets: {
            api: '/api/agora/broadcast-notifications/broadcast-count',
            method: 'GET',
            parameter: true
        },
        getBroadcastTargets: {
            api: '/api/agora/broadcast-notifications/broadcast-get-targets',
            method: 'POST',
            parameter: true
        }
    },
    masterTemplate: {
        list: {
            api: '/api/mercury/new-notifications/mastertemplate/list',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/mercury/new-notifications/mastertemplate/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/mercury/new-notifications/mastertemplate/edit',
            method: 'POST',
            parameter: false
        },
        details: {
            api: '/api/mercury/new-notifications/dictionary/htmltemplatedetails',
            method: 'GET',
            parameter: true
        }
    },
    dictionary: {
        standardPlaceholdersList: {
            api: '/api/mercury/new-notifications/dictionary/placeholders-standard',
            method: 'GET',
            parameter: false
        },
        htmlTemplates: {
            api: '/api/mercury/new-notifications/dictionary/htmltemplateslist',
            method: 'GET',
            parameter: false
        },
        htmlTemplateDetails: {
            api: '/api/mercury/new-notifications/dictionary/htmltemplatedetails',
            method: 'GET',
            parameter: false
        }
    },
    blacklist:{
        unsubscribe:{
            api: '/api/mercury/blacklist/unsubscribe',
            method: 'POST',
            parameter: true
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/notification-management.endpoints.ts